import { Module } from '@nu-art/ts-common';
import { ApiDef_CollectionActions } from '@nu-art/thunderstorm-shared/collection-actions/api-def';
import { apiWithBody } from '../core/typed-api.js';
class ModuleFE_CollectionActions_Class extends Module {
    upgrade;
    check;
    constructor() {
        super();
        this.upgrade = {
            collections: apiWithBody(ApiDef_CollectionActions.upgrade.collections),
            all: apiWithBody(ApiDef_CollectionActions.upgrade.all),
        };
        this.check = {
            usage: apiWithBody(ApiDef_CollectionActions.check.usage),
        };
    }
}
export const ModuleFE_CollectionActions = new ModuleFE_CollectionActions_Class();
//# sourceMappingURL=ModuleFE_CollectionActions.js.map